import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './styles.sass';

/**
 * A message group.
 *
 * @param  {Boolean} options.mine
 */
export var MessageGroup = function MessageGroup(_ref) {
  var mine = _ref.mine,
    name = _ref.name,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('MessageGroup')
  }, name && !mine && /*#__PURE__*/React.createElement("div", {
    className: "MessageGroup__name"
  }, name), children);
};
MessageGroup.propTypes = {
  mine: PropTypes.bool,
  name: PropTypes.string,
  children: PropTypes.node
};

/**
 * Conversation component.
 */
export var Conversation = /*#__PURE__*/function (_React$Component) {
  function Conversation() {
    _classCallCheck(this, Conversation);
    return _callSuper(this, Conversation, arguments);
  }
  _inherits(Conversation, _React$Component);
  return _createClass(Conversation, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "Conversation"
      }, this.props.children);
    }
  }]);
}(React.Component);
Conversation.propTypes = {
  children: PropTypes.node
};
export { default as Message, MessageBubble, CallMessageBubble, PromptMessageBubble } from './Message';
export { default as MessageDocument } from './MessageDocument';
//# sourceMappingURL=index.js.map
